import { type ICustomFieldType } from 'entities/CustomField'
import type { IMergeFieldType, IntegrationSettingsHubspotCheckboxes } from 'entities/Integrations'

type IPropertyMappingRules = {
  [P in ICustomFieldType]: IMergeFieldType[]
}
export const PROPERTY_MAPPING_RULES: IPropertyMappingRules = {
  number: ['number', 'text', 'string', 'double', 'phone'],
  text: ['text', 'string', 'address', 'varchar', 'enumeration'],
  url: ['url', 'text', 'string'],
  date: ['date', 'datetime'],
  datetime: ['datetime'],
}

export const PROPERTY_PHONE_TOOLTIP =
  "Salesmsg uses the first number; if it's missing, it defaults to the second."

import type { SettingsPropertyItemType } from 'pages/settings/pages/integrations/pages/integrationSettings/model/types'

export const HUBSPOT_SYNC_CHECKBOX_KEYS: IntegrationSettingsHubspotCheckboxes[] = [
  'update_contacts',
  'create_non_existing_contacts',
  'update_owner',
]

export const BANNED_IDS = ['firstname', 'lastname', 'email', 'phone']

const BASE_PROPERTIES = {
  phone: {
    id: 'number',
    fieldName: 'Phone',
    customSettingId: 'phone_number_priority',
    value: null,
    disabled: false,
    type: 'default' as const,
    tooltip: PROPERTY_PHONE_TOOLTIP,
  },
  firstName: {
    id: 'first_name',
    fieldName: 'First name',
    value: 'First name',
    disabled: true,
    type: 'default' as const,
  },
  lastName: {
    id: 'last_name',
    fieldName: 'Last name',
    value: 'Last name',
    disabled: true,
    type: 'default' as const,
  },
  email: {
    id: 'email',
    fieldName: 'Email',
    value: 'Email',
    disabled: true,
    type: 'default' as const,
  },
} as const

const createIntegrationProperties = (integrationName: string): SettingsPropertyItemType[] => [
  {
    ...BASE_PROPERTIES.phone,
    integrationName,
    // Override value for non-HubSpot integrations
    value: integrationName === 'HubSpot' ? null : 'Phone',
    disabled: integrationName !== 'HubSpot',
  },
  {
    ...BASE_PROPERTIES.firstName,
    integrationName,
  },
  {
    ...BASE_PROPERTIES.lastName,
    integrationName,
  },
  {
    ...BASE_PROPERTIES.email,
    integrationName,
  },
]

const HUBSPOT_PROPERTIES = createIntegrationProperties('HubSpot')
const KEAP_PROPERTIES = createIntegrationProperties('Keap')
const ACTIVE_CAMPAIGN_PROPERTIES = createIntegrationProperties('ActiveCampaign')
const PIPEDRIVE_PROPERTIES = createIntegrationProperties('Pipedrive')
const ZOHO_PROPERTIES = createIntegrationProperties('Zoho')

export const propertiesMap: Record<string, SettingsPropertyItemType[]> = {
  hubspot: HUBSPOT_PROPERTIES,
  activecampaign: ACTIVE_CAMPAIGN_PROPERTIES,
  infusionsoft: KEAP_PROPERTIES,
  pipedrive: PIPEDRIVE_PROPERTIES,
  zoho: ZOHO_PROPERTIES,
}
